export default {
  helloWorld: 'Hallo Welt!',
  routes: {
    pathPrefix: '',
    basePath: 'autoversicherung/antragsstrecke',
    motorbikeBasePath: 'motorradversicherung/antragsstrecke',
    insuranceRequest: '',
    agent: 'agent',
    productSelect: 'praemien',
    options: 'deckungen-anpassen',
    vehicleSelect: 'autosuche',
    vehicleSelectComfort: 'komfort',
    vehicleSelectVehicleNumber: 'typenschein',
    vehicleSelected: 'gewaehltesFahrzeug',
    vehicleData: 'autodaten',
    owner: 'halter',
    personalData: 'persoenliche-daten',
    checkout: 'eingabe-pruefen',
    offer: 'offerte-anfordern',
    referral: 'referral',
    confirmation: 'bestaetigung',
    infoLater: 'infos-spaeter',
    finish: 'vollstaendig',
    declined: 'ablehnung',
    rejected: 'bearbeitung',
    offerExpired: 'abgelaufen',
    error: 'fehler',
    maintenance: 'wartung',
    playground: 'playground',
  },
  errors: {
    graphqlQueryBase: 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    paper: 'in Papierform',
    electronic: 'elektronisch',
    vehicleNotFound: 'Fahrzeug wurde nicht gefunden. Bitte überprüfen Sie Ihre Eingabe oder nutzen Sie die Fahrzeugsuche.',
    technicalError: 'Es ist ein technischer Fehler aufgetreten. Bitte versuchen Sie es nochmal.',
    technicalErrorLater: 'Es ist ein technischer Fehler aufgetreten, der leider einige Zeit in Anspruch nehmen wird. Bitte versuchen Sie die Berechnung später erneut.',
    maintenance: 'Zur Zeit befindet sich das System im Wartungsmodus. Bitte versuchen Sie die Berechnung später erneut.',
    declined: 'Leider können wir Ihnen für Ihr Auto zum jetzigen Zeitpunkt keine Versicherung anbieten.',
  },
  basics: {
    age: 'Alter',
    plz: 'PLZ',
    gender: 'Anrede',
    genderFemale: 'Frau',
    genderMale: 'Herr',
    genderCompany: 'Firma',
    firstName: 'Vorname',
    lastName: 'Nachname',
    street: 'Strasse',
    houseNumber: 'Hausnummer',
    city: 'Wohnort',
    email: 'E-Mail',
    phone: 'Telefonnummer',
    dateOfBirth: 'Geburtsdatum',
    licence: 'Führerausweis',
    nationality: 'Nationalität',
    swiss: 'Schweiz',
    others: 'Andere',
    chooseOption: 'Bitte wählen',
    noResultsOption: 'Keine Ergebnisse',
    unknownOption: 'Weiss nicht',
    selectProduct: 'Produkt wählen',
    customizeCoverage: 'Deckung anpassen',
    vehicle: 'Fahrzeug',
    ovner: 'Halter',
    enterContract: 'Abschliessen',
    continue: 'weiter',
    back: 'zurück',
    reset: 'Angaben verwerfen',
    yes: 'Ja',
    no: 'Nein',
    notWanted: 'nicht gewünscht',
    datePlaceholder: 'TT.MM.JJJJ',
    yearPlaceholder: 'JJJJ',
    company: 'Name Firma',
    uid: 'UID',
    industry: 'Branche',
    vehicleType: 'Gefahren wird ein',
    flexDrive: 'FlexDrive',
    basisDrive: 'BasisDrive',
  },

  start: {
    head: {
      h1: 'Ihre neue Autoversicherung',
      h3: 'Jetzt Prämie Ihrer neuen Fahrzeugversicherung berechnen',
      p: 'Top Produkte, voll digital und trotzdem persönlich betreut - das ist Simpego.',
      list: {
        car: 'Personenwagen',
        van: 'Lieferwagen',
        vanRegisteredAsCar: 'Firmenfahrzeuge',
        motorbike: 'Motorräder',
      },
    },
    form: {
      personal: {
        h3: 'Persönliche Angaben',
        age1: 'Ich bin',
        age2: 'Jahre alt.',
        plz1: 'Meine PLZ lautet',
        otherNationality: 'Andere Nationalität',
        customerTypePerson: 'Privatkunde',
        customerTypeCompany: 'Firmenkunde',
        companyZip: 'PLZ der Firma',
        industry: 'Firmenbranche',
        industries: {
          industry1: 'Handel, Finanzen, Beratung, Immobilien, IT',
          industry2: 'Gastgewerbe, Tourismus und Reisen, Freizeit',
          industry3: 'Baugewerbe, Werkstätten, Maschinenbau',
          industry4: 'Herstellung, Entsorgung, Reinigung',
          industry5: 'Post-, Kurier-, Lieferdienst, Transportgewerbe',
          industry6: 'Schiff- und Luftfahrt',
          industry7: 'Vermietung von Fahrzeugen',
          industry8: 'Medizinische Versorgung, Heime, Veterinärwesen',
          industry9: 'Musik, Medien, Verlage, TV, Werbung',
          industry10: 'öffentl. Einrichtungen, Museen, Kirchen, Vereine',
          industry11: 'Landwirtschaft, Wasser, Energie, Chemie',
          industry12: 'Blaulichtorganisationen',
          industry13: 'sonstige',
        },
        ageOrYear: 'Alter/Geburtsjahr',
        zip: 'PLZ',
      },
      car: {
        h3: 'Fahrzeugangaben',
        searchmode1: 'Fahrzeug suchen',
        searchmode2: 'Typenschein eingeben',
        initialRegistrationYear: '1. Inverkehrssetzung (Jahr)',
        brand: 'Mein Fahrzeug ist von der Marke',
        model: 'Das Modell ist',
        fuelType: 'Es fährt mit (Treibstoff)',
        powerRange: 'Die Leistung beträgt (PS)',
        typeCertificateNumber: 'Die Nummer meines Typenscheins ist',
        typeCertificateNumber_placeholder: 'Ziffer 24 im Fahrzeugausweis',
        vehicleSearchError: 'Ihre Suche ergab leider kein Ergebnis.',
      },
      startOfInsurance: {
        h3: 'Versicherungsbeginn',
        startOfInsurance: 'Der gewünschte Beginn meiner Versicherung ist der',
      },
      sendButton: 'Prämien anzeigen',
    },
  },
  insurancerequest: {
    annoPrice: '/Jahr',
    from: 'ab',
    footerBackText: 'neu berechnen',
    declinedHeadline: 'Preisberechnung nicht möglich. Grund:',
  },
  customizeCoverage: {
    form: {
      deductible: {
        h3: 'Haftpflicht',
        h3Hint: 'Die obligatorische Haftpflichtversicherung übernimmt Schäden an fremden Sachen oder Personen, welche Sie als Lenker oder eine Person, für die Sie verantwortlich sind, mit Ihrem Fahrzeug verursachen. Und zwar in folgenden Situationen:<br><br> - durch den Betrieb des Fahrzeuges;<br> - bei Verkehrsunfällen, die vom Fahrzeug verursacht werden, wenn es nicht in Betrieb ist;<br> - bei Hilfeleistungen nach Unfällen des Fahrzeuges;<br> - beim Einsteigen in das Fahrzeug und Aussteigen aus dem Fahrzeug, beim Öffnen und Schliessen beweglicher Fahrzeugteile sowie beim An- und Abhängen eines Anhängers oder Fahrzeuges.<br><br>Die Simpego bezahlt berechtigte und wehrt unberechtigte Ansprüche für den Versicherten ab. Die Leistungen sind auf CHF 100 Millionen pro Ereignis begrenzt, einschliesslich allfälliger Schadenzinsen, Anwalts- und Gerichtskosten. Selbstbehalte bei Fahrern unter 25 Jahre: M zzgl. CHF 1\´500, L zzgl. CHF 1\´200 und XL zzgl. CHF 1\´000.',
        customizeCoverage: {
          label: 'Selbstbehalt in CHF',
          infoText: 'Wählen Sie Ihren individuellen Selbstbehalt. Diesen Betrag tragen Sie im Schadenfall selbst.',
          inputHint: 'Geben Sie einen Wert zwischen CHF {min} - {max} an',
        },
        customizeCoverage25: {
          label: 'Selbstbehalt für nicht deklarierte Lenker unter 25 Jahren',
          infoText: 'Dieser Selbstbehalt entfällt, wenn die Lenker unter 25 Jahren angegeben werden oder Sie selber unter 25 Jahre alt sind.',
          value: '+ CHF {value}',
        },
        fieldName: 'Selbstbehalt',
      },
      comprehensive: {
        h3: 'Kasko',
        comprehensiveOptions: {
          label: 'Kasko wählen',
          infoText: 'Vollkaskoversicherung (Teilkasko- und Kollisionskaskoversicherung)<br><br> Zusätzlich zu allen Leistungen der Teilkaskoversicherung sind Schäden durch plötzliche, gewaltsame, mechanische, unfreiwillige, äussere Einwirkung, also etwa durch Anprall, Zusammenstoss, Absturz oder Umkippen versichert.<br><br> Teilkaskoversicherung<br> Gedeckt sind Schäden infolge von Feuer, Elementarereignissen, Schneerutsch, Diebstahl, Kollision mit einem Tier, Marderschäden, Bruch der Scheiben (Glasbruch Basis), Vandalismus sowie Schäden infolge Absturz von Luft- und Raumfahrzeugen oder Teilen davon sowie Notlandung.',
        },
        partially_comprehensive: {
          label: 'Selbstbehalt Teilkasko in CHF',
          infoText: 'Wählen Sie Ihren individuellen Selbstbehalt. Diesen Betrag tragen Sie im Schadenfall selbst.',
          inputHint: 'Geben Sie einen Wert zwischen CHF {min} - {max} an',
        },
        fully_comprehensive: {
          label: 'Selbstbehalt Kollision in CHF',
          infoText: 'Wählen Sie Ihren individuellen Selbstbehalt. Diesen Betrag tragen Sie im Schadenfall selbst.',
          inputHint: 'Geben Sie einen Wert zwischen CHF {min} - {max} an',
        },
        deductible_under_25: {
          label: 'Selbstbehalt Kollision für nicht deklarierte Lenker unter 25 Jahren',
          infoText: 'Dieser Selbstbehalt entfällt, wenn die Lenker unter 25 Jahren angegeben werden oder Sie selber unter 25 Jahre alt sind.',
          value: '+ CHF {value}',
        },
      },
      comprehensiveOptions: {
        h3: 'Ergänzungen Kasko',
        park_damage: {
          label: 'Parkschadenschutz',
          infoText: 'Parkschaden Basis<br> Schäden am parkierten Fahrzeug durch unbekannte Dritte sind unter Berücksichtigung des gewählten Selbstbehaltes bis CHF 2\´000 pro Ereignis versichert. <br><br> Parkschaden Plus<br> Schäden am parkierten Fahrzeug durch unbekannte Dritte sind unter Berücksichtigung des gewählten Selbstbehaltes und ohne betragliche Begrenzung versichert. <br><br> Versichert sind maximal 2 Schäden pro Kalenderjahr.',
        },
        park_damage_deductible: {
          label: 'Selbstbehalt Parkschaden in CHF',
          infoText: 'Wählen Sie ihren individuellen Selbstbehalt. Diesen Betrag tragen Sie im Schadenfall selbst. Der Selbstbehalt der Parkschadendeckung muss kleiner als der Selbstbehalt der Kollisionskaskoversicherung sein.',
          inputHint: 'Geben Sie einen Wert zwischen CHF {min} - {max} an',
        },
        glass: {
          label: 'Glasbruch Plus (Kleinglas)',
          infoText: 'Im Rahmen der Teilkaskoversicherung sind nur Bruchschäden der Front-, Seiten- und Heckscheiben sowie des Glassschiebedachs versichert. Dabei sind auch Werkstoffe versichert, die als Glasersatz dienen (Glasbruch Basis).<br><br>Glasbruch Plus (Kleinglas)<br>Es sind zusätzlich Bruchschäden an allen weiteren Fahrzeugteilen aus Glas (inkl. Kleingläser wie Scheinwerfer, Blinker etc.) versichert. Dabei sind auch Werkstoffe versichert, die als Glasersatz dienen. Mitversichert sind zudem Glühlampen und Leuchtdioden (LED), sofern sie beim Glasbruch zerstört werden.',
        },
        personal_effects_coverage: {
          label: 'Wert mitgeführte Sachen in CHF',
          infoText: 'Versichert sind die von Insassen mitgeführten persönlichen Sachen, die mit oder aus dem abgeschlossenen Fahrzeug gestohlen oder bei einem versicherten Schaden am Fahrzeug beschädigt werden. Die Simpego bezahlt bis zur vereinbarten Versicherungssumme die Reparatur, bei Totalschaden den Betrag für die Neuanschaffung.',
        },
        free_garage: {
          label: 'Reparaturmodell im Schadenfall',
          infoText: 'Reparaturmodell Partnergarage<br><br>Sie verpflichten sich uns Kaskoschäden vor der Reparatur zu melden und die Reparatur in einer <a href="https://blog.simpego.ch/partnergaragen/" target="blank">Partnergarage</a> von simpego vornehmen zu lassen. Dafür profitieren Sie von günstigeren Kaskoprämien. Falls Sie sich im Schadenfall nicht an die Vereinbarung halten, wird der Vertrag auf das Reparaturmodell "Freie Garagenwahl" umgestellt und die Differenzprämie muss für max. 1 Jahr nachbezahlt werden.<br><br><br> Reparaturmodell Freie Garagenwahl <br><br>Sie können den Reparaturbetrieb frei wählen.',
          options: {
            true: 'Freie Garagenwahl',
            false: 'Partnergarage',
          },
        },
        suspension: {
          label: 'Bei Sistierung',
          text: 'keine Prämienrückerstattung',
          infoText: 'Wenn Sie die Schilder temporär deponieren, wird die Prämie nicht anteilsmässig zurückerstattet.',
        },
        protective_clothing: {
          label: 'Schutzbekleidung (inkl. Beifahrer zum Neuwert)',
          infoText: ' Im Zusammenhang mit einem versicherten Kaskoereignis, ist die Schutzbekleidung des Fahrers inkl. Sozius (Beifahrer) zum Neuwert versichert. Als Schutzbekleidung gelten Helme, Schutzbrillen, Handschuhe, Stiefel, Protektoren, Kombi und Schutzanzüge.',
          fieldName: 'Schutzbekleidung',
        },
      },
      passenger_accident: {
        label: 'Unfallversicherung',
        labelHint: 'Alle Insassen, Leistungen pro Person, Heilungskosten versichert',
        infoText: 'Unsere Unfallversicherung schützt Sie und alle Insassen vor den finanziellen Folgen, wenn Sie mit dem versicherten Fahrzeug verunfallen.<br><br> Für alle Varianten gilt: Heilungskosten - Privatabteilung. Abweichungen in der Deckung gibt es bei Taggeldern, Invaliditätskapital und Todesfallkapital.<br><br> Standard: Taggelder CHF {DexCarM_daily_compensation}, Invalidität CHF {DexCarM_disability_capital}, Todesfall CHF {DexCarM_death_benefit}<br><br> Basis: Taggelder CHF {DexCarL_daily_compensation}, Invalidität CHF {DexCarL_disability_capital}, Todesfall CHF {DexCarL_death_benefit}<br><br> Plus: Taggelder CHF {DexCarXl_daily_compensation}, Invalidität CHF {DexCarXl_disability_capital}, Todesfall CHF {DexCarXl_death_benefit}<br><br> Alle Leistungen gelten pro Person. Die Leistungen werden sofort gezahlt, also bereits vor der Schuldklärung. Die Leistungen für Invalidität und Todesfall werden zusätzlich zu Leistungen der Haftpflichtversicherung und anderen Unfallversicherungen ausbezahlt.<br><br> Wird ein mitgeführtes Haustier im Fahrzeug verletzt, übernehmen wir die Heilbehandlung bis CHF 2\´500 pro Tier und höchstens bis CHF 5\´000 pro Ereignis.',
      },
      negligence: {
        label: 'Grobfahrlässigkeit',
        infoText: 'Wir bieten Ihnen auch dann vollen Versicherungsschutz, wenn der Unfall grob fahrlässig verursacht wurde - etwa wenn Sie kurz abgelenkt waren und eine rote Ampel übersehen haben. In solchen Fällen verzichten wir auf unser Rückgriffs- bzw. Kürzungsrecht. Dies gilt jedoch nicht, wenn die Fahrtüchtigkeit durch Alkohol, Drogen oder Medikamentenmissbrauch eingeschränkt war.',
      },
      assistance24: {
        label: '24h-Assistance',
        infoText: 'Unsere Leistungen geben Ihnen bei Pannen und Unfällen die nötige Sicherheit: Wir übernehmen die Organisation und Kosten der Hilfe vor Ort bei Pannen und Unfällen und stellen Ihre Mobilität sicher.<br><br> Bei Assistance Basis und Plus sind u.a. folgende Hilfeleistungen versichert:<br> Pannenhilfe, Abschleppen und Fahrzeugbergung bis zur nächstgelegenen, geeigneten Reparaturwerkstatt (Basis), Fahrzeugbergung bis zu einer Garage nach Wahl (Plus), Übernachtungskosten, Reisekosten, Rücktransport des Fahrzeugs, Sicherstellen Mobilität (mit Miet-/Ersatzwagen, ÖV, Taxi) bis CHF 1\´500 (Basis) resp. CHF 4\´000 (Plus), Benachrichtigungsservice.',
      },
      daily_termination: {
        label: 'Tägliches Kündigungsrecht',
      },
      payment_frequency: {
        label: 'Zahlweise',
        infoText: 'Sie können Ihre Prämie halbjährlich oder jährlich im Voraus bezahlen. Bei unterjähriger Zahlweise wird ein Zuschlag erhoben.',
      },
      payment_type: {
        label: 'Zahlungsart',
        invoice: 'auf Rechnung',
        creditCard: 'Kreditkarte',
      },
      document_delivery: {
        label: 'Zustellart der Dokumente',
        infoText: 'Alle Dokumente werden Ihnen elektronisch zugestellt.',
        email: 'elektronisch per Email',
      },
      taxesTotal: {
        label: 'Gesetzliche Abgaben',
        infoText: 'Die gesetzlichen Abgaben setzen sich wie folgt zusammen: <br> - Stempelsteuer 5% der Haftpflicht- und Kaskoprämie<br> - Abgabe SVG CHF 4.20 (gemäss Artikel 74 und 76a SVG, auf der Haftpflichtprämie)<br> - Unfallverhütungsbeitrag 0.75% der Haftpflichtprämie',
      },
      priceTotal: {
        label: 'Gesamtjahresprämie',
        infoText: 'Ihre Prämie gemäss gewählter Zahlweise inkl. aller Gebühren und Abgaben',
      },
      errors: {
        vehicleLeasing: 'Geleaste Fahrzeuge benötigen eine Kollisionskasko.',
      },
    },
    customized: 'individualisiert',
    comprehensives: {
      notWanted: 'nicht gewünscht',
      liability: 'Haftpflicht',
      partially_comprehensive: 'Teilkasko',
      fully_comprehensive: 'Vollkasko',
    },
  },
  vehicleSelect: {
    basics: {
      initialRegistrationYear: 'Erste Inverkehrssetzung',
      chooseCar: {
        text: 'Fahrzeug wählen',
        infoText: 'Bitte wählen Sie Ihr Fahrzeug möglichst genau aus. Geringfügige Abweichungen des Fahrzeugtyps sind in der Regel kein Problem und haben keinen Einfluss auf die Versicherungsprämie. Das Strassenverkehrsamt meldet uns bei der Einlösung Ihre genauen Fahrzeugdaten zurück. Sollte sich eine grössere Abweichung ergeben, melden wir uns bei Ihnen.',
      },
    },
    comfort: {
      brand: 'Marke',
      model: 'Modell',
      fuelType: 'Treibstoff',
      vehicleCategory: 'Kategorie',
      vehiclePower: 'PS',
      transmission: 'Getriebe',
    },
    vehicleNumber: {
      typeCertificateNumber: {
        label: 'Typenschein',
        placeholder: 'Ziffer 24 im Fahrzeugausweis',
      },
    },
    selected: {
      headline: {
        text: 'Ihr gewähltes Fahrzeug',
        infoText: 'Bitte wählen Sie Ihr Fahrzeug möglichst genau aus. Geringfügige Abweichungen des Fahrzeugtyps sind in der Regel kein Problem und haben keinen Einfluss auf die Versicherungsprämie. Das Strassenverkehrsamt meldet uns bei der Einlösung Ihre genauen Fahrzeugdaten zurück. Sollte sich eine grössere Abweichung ergeben, melden wir uns bei Ihnen.',
      },
      btn1: 'Neues Fahrzeug wählen',
      btn2: 'Fahrzeug übernehmen',
    },
  },
  vehicleData: {
    headline: 'Fahrzeugangaben',
    ownedSince: {
      label: 'Im Besitz seit',
      infoText: 'Geben Sie an, wie lange Sie schon im Besitz des Fahrzeugs sind.',
    },
    canton: {
      label: 'Zulassungskanton',
      infoText: 'Geben Sie den Kanton an, in dem das Fahrzeug angemeldet werden soll.',
    },
    businessUsage: {
      label: 'Wird das Fahrzeug für Dienstfahrten verwendet?',
      infoPerson: 'Verwenden Sie das Fahrzeug auch im Auftrag des Arbeitgebers? z.B. Aussendienst',
      infoCompany: 'Verwenden Sie das Fahrzeug auch geschäftlich?',
    },
    transport: {
      label: 'Wird das Fahrzeug für den kommerziellen, gewerbsmässigen Personen- resp. Warentransport verwendet?',
      infoText: 'Die kommerzielle, gewerbliche Nutzung ist gegeben, wenn Ihre (Geschäfts-)Interessen darauf ausgelegt sind, durch den Transport von Waren oder Personen Gewinn zu erwirtschaften.',
    },
    leasing: {
      label: 'Leasing',
      infoText: 'Bitte geben Sie an, ob das Fahrzeug geleast ist. Beachten Sie dabei bitte, dass für ein geleastes Fahrzeug in der Regel eine Vollkaskoversicherung benötigt wird.',
    },
    startOfInsurance: {
      label: 'Gewünschter Versicherungsbeginn',
      infoText: 'Wählen Sie hier Ihren individueller Versicherungsbeginn. Zu diesem Zeitpunkt beginnt Ihre Versicherung.',
    },
    errors: {
      vehicleLeasing: 'Geleaste Fahrzeuge benötigen eine Kollisionskasko. Wir haben Ihre Deckung für Sie entsprechend angepasst.',
    },
    vehicleRegistrationType: {
      label: 'Das Fahrzeug wird zugelassen als',
      info: 'Geben Sie an, ob das Fahrzeug als Lieferwagen oder als Personenwagen eingelöst wird.',
      car: 'Personenwagen',
      van: 'Lieferwagen',
      carOrVan: 'Personenwagen / Lieferwagen',
      motorbike: 'Motorrad',

    },
    truckExtEquipment: {
      label: 'Haben Sie für dieses Fahrzeug zusätzliche Aufbauten?',
      info: 'Als Aufbauten gelten am Lieferwagen fest montierte Fahrzeugaufbauten (z.B. Kastenaufbau, Brücke, Kipper, etc.), die ausschliesslich für die Verwendung mit dem versicherten Fahrzeug vorgesehen und nicht im Katalogpreis des Fahrzeuges inbegriffen sind. Nicht zum Aufbau gehören darin beförderte Sachen.',
      inputHint: 'Geben Sie einen Wert zwischen CHF 0 - 999\´999 an',
      fieldName: 'Aufbautenwert',
    },
    truckIntEquipment: {
      label: 'Hat das Fahrzeug spezielle Einbauten?',
      info: 'Als Einbauten gelten am Lieferwagen fest montierte Fahrzeugeinrichtungen (z.B. für Servicewagen, Hauswartung, etc.), die ausschliesslich für die Verwendung mit dem versicherten Fahrzeug vorgesehen und nicht im Katalogpreis des Fahrzeuges inbegriffen sind. Nicht zum Einbau gehören darin beförderte Sachen.',
      inputHint: 'Geben Sie einen Wert zwischen CHF 0 - 999\´999 an',
      fieldName: 'Einbautenwert',
    },
  },
  owner: {
    headline: 'Halterangaben',
    nationality: {
      label: 'Nationalität',
      infoText: 'Bitte achten Sie darauf, dass Sie sich beim Strassenverkehrsamt mit der gleichen Nationalität ausweisen.',
    },
    residencePermit: {
      label: 'Aufenthaltsbewilligung',
      infoText: 'Geben Sie den Typ Ihrer Aufenthaltsbewilligung ein.',
      B1: 'B',
      C: 'C',
      L: 'übrige',
    },
    driverLicenceSinceYear: {
      label: 'Führerausweis seit (Jahr)',
      infoText: 'Geben Sie bitte an, seit wann Sie einen Personenwagen im Verkehr führen dürfen. Ein Mindestalter von 17 Jahren ist erforderlich.',
    },
    isKeeperMainDriver: {
      label: 'Ist der Fahrzeughalter der häufigste Lenker?',
      infoText: 'Geben Sie bitte an, ob jemand anderes als Sie als Fahrzeughalter der häufigste Nutzer des Fahrzeugs ist.',
    },
    youngDriver: {
      label: 'Nutzen Personen unter 25 Jahren das Fahrzeug?',
      infoText: 'Bitte geben Sie an, ob Personen unter 25 Jahren das Fahrzeug nutzen.',
      youngDriverOptions: {
        male: 'ja, männlich',
        female: 'ja, weiblich',
        both: 'ja, beides',
      },
    },
    driverLicenceWithdrawal: {
      label: 'Wurde Ihnen in den letzten 5 Jahren der Führerausweis für länger als 3 Monate entzogen, eine Police gekündigt oder abgelehnt?',
      labelMainDriver: 'Wurde Ihnen oder dem häufigsten Lenker in den letzten 5 Jahren der Führerausweis für länger als 3 Monate entzogen, eine Police gekündigt oder abgelehnt?',
      infoPerson: 'Bitte geben Sie an, ob Ihnen in den letzten 5 Jahren der Führerschein entzogen wurde, eine Versicherung Ihren Antrag abgelehnt hat oder Ihnen ein Versicherungsvertrag gekündigt oder die Weiterführung an erschwerte Bedingungen geknüpft wurde.',
      infoCompany: 'Bitte geben Sie an, ob Ihnen in den letzten 5 Jahren eine Versicherung einen Antrag abgelehnt hat oder Ihnen ein Versicherungsvertrag gekündigt oder die Weiterführung an erschwerte Bedingungen geknüpft wurde.',
      infoMainDriver: 'Bitte geben Sie an, ob Ihnen oder dem häufigsten Lenker in den letzten 5 Jahren der Führerschein entzogen wurde, eine Versicherung Ihren Antrag abgelehnt hat oder Ihnen ein Versicherungsvertrag gekündigt oder die Weiterführung an erschwerte Bedingungen geknüpft wurde.',
    },
    policyCancelledOrRejected: {
      label: 'Wurde Ihnen in den letzten 5 Jahren eine Police gekündigt oder abgelehnt?',
    },
    tooManyAccidents: {
      label: 'Hatten Sie 3 oder mehr Schadenfälle in den letzten 3 Jahren?',
      labelMainDriver: 'Hatten Sie oder der häufigste Lenker 3 oder mehr Schadenfälle in den letzten 3 Jahren?',
      infoText: 'Deklarieren Sie alle Schadenfälle der letzten 3 Jahre, bei welchen Ihre Versicherung eine Leistung erbracht hat. Beispielsweise Haftpflichtschäden, Kollisionsschäden, Parkschäden, Marderschäden, Glasschäden etc.',
      infoMainDriver: 'Deklarieren Sie alle Schadenfälle der letzten 3 Jahre, bei welchen Ihre Versicherung oder die Versicherung des häufigsten Lenkers eine Leistung erbracht hat. Beispielsweise Haftpflichtschäden, Kollisionsschäden, Parkschäden, Marderschäden, Glasschäden etc.',
    },
  },
  personalData: {
    headline: {
      agent: 'Vermittlerdaten',
      person: 'Persönliche Daten',
      personForAgent: 'Persönliche Daten des Kunden',
    },
    agentEmail: {
      label: 'Vermittler Email',
    },
    customerDocuments: {
      label: 'Steuerung der Kundendokumente',
      infoText: 'Wählen Sie, ob die Dokumente nur an Sie oder direkt dem Kunden bzw. dem Kunden mit Ihnen in Kopie zugestellt werden sollen.<br><br> Betroffen sind die Dokumente: <br> - Vertragsdokumente inkl. Erstrechnung <br> - Erneuerungsdokumente inkl. Rechnung',
      toAgent: 'nur an Vermittler',
      toCustomer: 'nur an Kunde',
      toCustomerAndAgent: 'an Kunde cc Vermittler',
    },
    invoices: {
      label: 'Steuerung der unterjährigen Folgerechnungen',
      infoText: 'Wählen Sie, ob die unterjährigen Folgerechnungen nur an Sie oder direkt dem Kunden bzw. dem Kunden mit Ihnen in Kopie zugestellt werden sollen. Betroffen sind die Folgerechnungen ohne Erneuerung. Über die Versandsteuerung der unterjährigen Folgerechnungen wird auch der Versand der Kreditkartenmails (wie Registrierung, nicht mögliche Abbuchung oder Information zur abgelaufenen oder invaliden Kreditkarte) gesteuert, daher ist bei Zahlungsart Kreditkarte «nur an Kunde» ausgewählt und nicht änderbar.',
    },
    reminders: {
      label: 'Steuerung der Inkassodokumente',
      infoText: 'Wählen Sie, ob die Dokumente nur an Sie oder direkt dem Kunden bzw. dem Kunden mit Ihnen in Kopie zugestellt werden sollen. Betroffen sind die Dokumente: <br> - Friendly Reminder <br> - Erinnerungen <br> - Mahnungen (die Mahnung wird immer zusätzlich per Post direkt an den Kunden gesendet)',
    },
    agentMailsDelivery: {
      label: 'Steuerung Emails',
      infoText: 'Aus dem Online Salesfunnel versendeten Emails werden an die angezeigte Vermittler-Mailadresse verschickt, bei Auswahl Vermittler bzw. Kunde cc Vermittler. <br> Wenn Auswahl «Kunde» werden die Mails nur an den Kunde gesendet<br><br>Betroffene Mails:<br> - Offertmails <br> - Bestätigungsmail für den Eingang des Abschlusses<br> - Bestätigung Ausstellung Versicherungsnachweis<br> - etwaige Nachfassmails',
      dispatchDocumentOptions: {
        option1: 'an Kunde cc Vermittler',
        option2: 'nur an Vermittler',
        option3: 'nur an Kunde',
      },
      toAgent: 'nur an Vermittler',
      toCustomer: 'nur an Kunde',
      toCustomerAndAgent: 'an Kunde cc Vermittler',
    },
    btn: 'Eingaben überprüfen',
    errors: {
      zipCode: 'Bitte geben Sie eine gültige PLZ an.',
    },
    industry: {
      infoText: 'Bitte geben Sie Ihre Branche gemäss Handelsregistereintrag an.',
    },
    emailInfoText: 'Wir benötigen diese Adresse, um eine Kundenakte zu eröffnen. Alle Emails im Zusammenhang mit dieser Offerte (z.B. Offert- oder Nachfassmails) oder die Bestätigung über den Eingang des Versicherungsabschlusses (Abschlussmail) werden Ihnen an die oben gewählte Vermittler-Mailadresse geschickt,  nicht jedoch an den Kunden. An wen nach der Policierung die Dokumente versendet werden sollen, steuern Sie bitte direkt über das Feld "Steuerung Kundendokumente".',
    warningAgentEmail: 'Bitte überprüfen Sie Ihre Eingabe. Die Kundenemailadresse kann nicht identisch sein mit einer Ihrer Vermittler-Emailadressen',
  },
  priceBox: {
    tariffOptions: {
      liabilityDeductible: 'Haftpflicht <em>Selbstbehalt (CHF {deductible})</em>',
      partiallyComprehensiveDeductible: 'Teilkasko <em>Selbstbehalt (CHF {deductible})</em>',
      fullyComprehensiveDeductible: 'Kollisionskasko <em>Selbstbehalt (CHF {deductible})</em>',
      parkDamageDeductible: 'Parkschaden <em>Selbstbehalt (CHF {deductible})</em>',
      freeGarage: 'Reparaturmodell: <em>{free_garage}</em>',
      protectiveClothing: 'Schutzbekleidung <em>(CHF {value})</em>',
      glass: 'Glasbruch Plus (Kleinglas)',
      personalEffectsCoverage: 'Mitgeführte Sachen (CHF {coverage})',
      parkDamage: 'Parkschadenschutz <span class="{bundleClass}">{bundle}</span>',
      passengerAccident: 'Unfallversicherung <span class="{bundleClass}">{bundle}</span>',
      grossNegligence: 'Grobfahrlässigkeit',
      assistance24: '24h-Assistance <span class="{bundleClass}">{bundle}</span>',
      dailyTermination: 'Tägliches Kündigungsrecht',
    },
    pricePerYear: '{price} /Jahr',
    pricePerKm: '{price} /km',
    maxPerYear: 'max. {price} CHF /Jahr',
    exactKm: 'kilometergenau',
  },
  checkout: {
    headline: {
      h3: 'Zusammenfassung Ihrer Offerte',
      text: 'Nur noch ein Klick und Sie haben eine neue Autoversicherung. Bitte überprüfen Sie jetzt noch einmal Ihre bisher gemachten Eingaben.',
    },
    summary: {
      basics: {
        headline: 'Allgemeine Versicherungsdaten',
        pricePerYear: 'Jahr',
        startOfInsurance: 'Versichert ab',
        priceWithKmPremium: '{fix}/Jahr + {perKm}/km, max. {max}/Jahr',
        onlyKmPremium: '{perKm}/km, max. {max}/Jahr',
      },
      car: {
        headline: 'Fahrzeugdaten',
        registrationType: 'Zulassungsart',
        truckEquipmentLabel: 'Zusätzliche Auf- und Einbauten',
      },
      payment: {
        billingModel: 'Abrechnungsmodell',
        headline: 'Zahlungsinformationen',
        billEmail: 'Rechnung per E-Mail',
        documentsEmail: 'elektronisch per Email',
        creditCard: 'Kreditkarte',
        monthly: 'monatlich',
        yearly: 'jährlich',
        half_yearly: 'halbjährlich',
        quarterly: 'vierteljährlich',
      },
      checkoutlegal_checkbox: {
        agent: {
          part1: 'Ich bestätige, dass der Kunde die für Ihn gültigen',
          part2: 'Allgemeinen Vertragsbedingungen (AVB)',
          part3: 'und',
          part4: 'Produktinformationen',
          part5: 'zur Kenntnis genommen hat und diese akzeptiert. Ich bestätige zudem, dass ich zum Abschluss dieses Vertrages bevollmächtigt bin resp. über ein unterzeichnetes Mandat verfüge. Desweiteren bestätige ich, die Informationspflicht ggü. dem Kunden gemäss VAG Art. 45 wahrgenommen zu haben.',
        },
        person: {
          part1: 'Ja, ich möchte online einen Versicherungsvertrag abschliessen und bestätige, dass ich die',
          part2: 'Allgemeinen Vertragsbedingungen (AVB)',
          part3: 'sowie die',
          part4: 'Produktinformationen',
          part5: 'zur Kenntnis genommen habe und akzeptiere.',
        },
      },
      btn: {
        signContact: 'Vertrag abschliessen',
        requestProposal: 'Offerte anfordern',
      },
      consultationProtocol: {
        input: 'Upload des Beratungsprotokolls bzw. Kundenmandats',
        tooltip: 'Sie haben hier die Möglichkeit Ihr Beratungsprotokoll bzw. das Kundenmandat hochzuladen.\n'
          + 'Dieses wird dann zusammen mit der Offertanfrage an simpego übergeben und zu der\n'
          + 'jeweiligen Offerte abgelegt. Wenn Sie mehrere Offertvarianten rechnen, wird das\n'
          + 'hochgeladene Dokument Ihnen bei jeder Offerte angezeigt und Sie haben die Möglichkeit\n'
          + 'dieses zu löschen und ein Neues hochzuladen.',
        errors: {
          size: 'Größe darf nicht mehr als 5MB betragen',
          type: 'Der Upload des Dokuments ist leider schief gelaufen. Zulässige Formate für das Dokument sind: pdf, jpeg, png.',
        },
      },
      tariffOptions: {
        liabilityDeductible: 'Selbstbehalt Haftpflicht (CHF {deductible})',
        partiallyComprehensiveDeductible: 'Selbstbehalt Teilkasko (CHF {deductible})',
        fullyComprehensiveDeductible: 'Selbstbehalt Kollision (CHF {deductible})',
        parkDamageDeductible: 'Selbstbehalt Parkschaden (CHF {deductible})',
        protectiveClothing: 'Schutzbekleidung (CHF {value})',
        glass: 'Glasbruch Plus (Kleinglas)',
        freeGarage: 'Reparaturmodell: {free_garage}',
        personalEffectsCoverage: 'Mitgeführte Sachen (CHF {coverage})',
        parkDamage: 'Parkschadenschutz {bundle}',
        passengerAccident: 'Unfallversicherung {bundle}',
        grossNegligence: 'Grobfahrlässigkeit',
        assistance24: '24h-Assistance {bundle}',
        dailyTermination: 'Tägliches Kündigungsrecht',
        suspension: 'Bei Sistierung: keine Prämienrückerstattung',
      },
    },
    errors: {
      applyContract: 'Es ist ein Fehler aufgetreten.',
      requestProposal: 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    },
    specialConditions: {
      payPerKM: {
        title: 'Besondere Bedingungen: Car FlexDrive',
        conditions: [
          {
            text: 'Bei Widersprüchen zwischen den für den Versicherungsvertrag geltenden Allgemeinen Versicherungsbedingungen (AVB) und diesen Besonderen Bedingungen (BB) gelten die BB.',
          },
          {
            headline: 'Was ist Car FlexDrive:',
            text: 'Mit FlexDrive basiert ein Teil oder die gesamte Prämie für Ihren Versicherungsvertrag auf der Anzahl Kilometer, die mit dem versicherten Fahrzeug zurückgelegt werden. Pro Kilometer wird die im Versicherungsvertrag festgehaltene Prämie fällig. Eine allfällig vereinbarte Fixprämie wird unabhängig von den gefahrenen Kilometern fällig.',
          },
          {
            headline: 'Maximalbetrag pro Jahr:',
            text: 'Die maximal fällige Prämie pro Jahr (Maximalbetrag) ist in Ihrem Versicherungsvertrag festgehalten. Ist der Maximalbetrag erreicht, erfolgt keine weitere Prämienbelastung für den Rest des Versicherungsjahres, sofern der Vertrag unverändert bleibt.',
          },
          {
            headline: 'Prämienzahlung und Folgen bei Nichtbezahlung:',
            text: 'Einmal monatlich erfolgt eine Belastung der Kreditkarte, die Sie in der autoSense App hinterlegt haben. Belastet wird die Prämie pro Kilometer für die im Vormonat zurückgelegte Strecke und ein Zwölftel der allfälligen Fixprämie. Der belastete Betrag enthält bereits die gesetzlichen Abgaben und Gebühren. Für jede Belastung stellt Ihnen die Simpego auf elektronischem Weg eine Abrechnung zu. Diese enthält die Anzahl zurückgelegter Kilometer, die dafür anfallende Prämie und die allfällige Fixprämie. Kann der geschuldete Betrag nicht innerhalb von 30 Tagen der Kreditkarte, die Sie in der autoSense App hinterlegt haben, belastet werden, hat die Simpego das Recht, den im Vertrag festgehaltenen Maximalbetrag sofort einzufordern. Für die Forderung des Maximalbetrages stellen wir Ihnen eine Rechnung zu. Vom Maximalbetrag abgezogen werden dabei die für dieses Versicherungsjahr bereits bezahlten Prämien. Für den Rest der Vertragslaufzeit erfolgt keine weitere Prämienbelastung, sofern der Vertrag unverändert bleibt.',
          },
          {
            headline: 'Forderungen im Zusammenhang mit Schadenfällen:',
            text: 'Für Selbstbehalte und Rückforderungen, die im Zusammenhang mit Schadenfällen anfallen, stellen wir Ihnen eine Rechnung zu. Diese Beträge werden nicht der Kreditkarte belastet.',
          },
          {
            headline: 'Bedingung für die Nutzung von Car FlexDrive:',
            text: 'Für die Nutzung von FlexDrive verpflichten Sie sich, den Fahrzeugadapter von autoSense während der Vertragslaufzeit nicht, oder nur in begründeten Fällen, vom Fahrzeug zu entfernen.',
          },
          {
            headline: 'Disconnects:',
            text: 'Wird der autoSense Adapter vom Fahrzeug entfernt, erfolgt ein sogenannter Disconnect. Dieser wird von autoSense an Simpego gemeldet, ebenso der Connect, sobald der Adapter wieder angeschlossen wird. Wurde das Fahrzeug während einem Disconnect, also ohne angeschlossenen Adapter, mehr als 100 Meter bewegt (Differenz Kilometerstand des Fahrzeuges zwischen Disconnect und Connect), kann die Simpego eine schriftliche Begründung von Ihnen verlangen. Die Simpego behält sich zudem das Recht vor, nach einem Disconnect auf die Weiterführung der Abrechnung pro Kilometer zu verzichten. In diesem Fall wird der im Vertrag festgehaltene Maximalbetrag sofort fällig. Vom Maximalbetrag abgezogen werden dabei die für dieses Versicherungsjahr bereits bezahlten Prämien. Für den Rest der Vertragslaufzeit erfolgt keine weitere Prämienbelastung, sofern der Vertrag unverändert bleibt. Für die Forderung des Maximalbetrages stellen wir Ihnen eine Rechnung zu. Diese Beträge werden nicht der Kreditkarte belastet.',
          },
          {
            headline: 'Hinterlegung der Kontrollschilder (Sistierung):',
            text: 'FlexDrive Versicherungsverträge, die eine Fixprämie beinhalten, verändern sich nicht, wenn die Kontrollschilder beim Strassenverkehrsamt hinterlegt werden, das versicherte Fahrzeug aber in Ihrem Besitz bleibt. Die Fixprämie ist auch dann fällig, wenn die Kontrollschilder hinterlegt wurden (Stillstandrisikodeckung). FlexDrive Versicherungsverträge, die keine Fixprämie beinhalten, werden per Datum der Schilderhinterlegung aufgehoben.',
          },
          {
            headline: 'Kündigung und Abrechnung:',
            text: 'Wird der Vertrag durch Sie oder die Simpego gekündigt, erfolgt die Aufhebung per dem vom Strassenverkehrsamt gemeldeten Datum. Ihrer in der autoSense App hinterlegten Kreditkarte werden nur noch die bis zur Vertragsaufhebung zurückgelegten Kilometer und der pro rata Anteil der allfälligen Fixprämie belastet. Der Maximalbetrag ist nach einer Aufhebung in den folgenden zwei Fällen immer geschuldet: 1. Sie kündigen den Vertrag aufgrund eines Teilschadens im ersten Versicherungsjahr und die Simpego hat für den Schaden die Versicherungsleistung erbracht; 2. Der Vertrag wird aufgrund eines Totalschadens (und damit Wegfalls des versicherten Risikos) aufgehoben, und die Simpego hat für den Schaden die Versicherungsleistung erbracht. Vom Maximalbetrag abgezogen werden dabei die für dieses Versicherungsjahr bereits bezahlten Prämien. Für die Forderung des Maximalbetrages nach einer Aufhebung stellen wir Ihnen eine Rechnung zu. Diese Beträge werden nicht der Kreditkarte belastet.',
          },
          {
            headline: 'Datenaustausch autoSense - Simpego:',
            text: 'Zwischen der autoSense AG und der Simpego Versicherungen AG findet ab dem Zeitpunkt der Vertragsaktivierung folgender Datenaustausch statt:',
          },
          {
            text: 'Simpego meldet autoSense: Vertragsstatus, Versicherungsdeckung, Status der Versicherungsdeckung, Angaben zum versicherten Fahrzeug, zu belastende Prämie für den Vormonat.',
          },
          {
            text: 'autoSense meldet Simpego: Adapterstatus (Disconnect / Connect), gefahrene Kilometer innerhalb des örtlichen Geltungsbereichs gemäss AVB, Transaktionscode der Zahlung.',
          },
          {
            text: 'Es werden zwischen Simpego und autoSense keine Informationen zu Ihrem Fahrverhalten, zu Ihrem Standort oder dem Standort des Fahrzeuges oder Informationen im Zusammenhang mit Schadenfällen ausgetauscht.',
          },
        ],
        privacy: {
          part1: 'Mehr Informationen zum Datenschutz bei Simpego finden Sie im Abschnitt „Datenschutz“ unserer ',
          part2: 'Produktinformationen',
          part3: '.',
        },
      },
      kasko2go: {
        title: 'Besondere Bedingungen: kasko2go powered by Simpego',
        conditions: [
          {
            text: 'Bei Widersprüchen zwischen den für den Versicherungsvertrag geltenden Allgemeinen Versicherungsbedingungen (AVB) und diesen Besonderen Bedingungen (BB) gelten die BB.',
          },
          {
            headline: 'Was ist kasko2go powered by Simpego',
            text: 'Mit kasko2go powered by Simpego basiert ein Teil oder die gesamte Prämie für Ihren Versicherungsvertrag auf der Anzahl Kilometer, die mit dem versicherten Fahrzeug zurückgelegt werden und auf dem von kasko2go berechneten Score (Benotung) Ihres Fahrverhaltens. Eine allfällig vereinbarte Fixprämie wird unabhängig von den gefahrenen Kilometern und dem kasko2go Score fällig.',
          },
          {
            headline: 'Maximalbetrag pro Jahr',
            text: 'Die maximal fällige Prämie pro Jahr (Maximalbetrag) ist in Ihrem Versicherungsvertrag festgehalten. Ist der Maximalbetrag erreicht, erfolgt keine weitere Prämienbelastung für den Rest des Versicherungsjahres, sofern der Vertrag unverändert bleibt.',
          },
          {
            headline: 'Prämieneinzahlung und Folgen bei Nichtbezahlung',
            text: 'Einmal monatlich erfolgt eine Belastung der Kreditkarte, die Sie in der kasko2go App hinterlegt haben. Belastet wird die Prämie pro Kilometer für die im Vormonat zurückgelegte Strecke und ein Zwölftel der allfälligen Fixprämie für den Folgemonat. Der belastete Betrag enthält bereits die gesetzlichen Abgaben und Gebühren. Kann der geschuldete Betrag nicht innerhalb von 10 Tagen der Kreditkarte, die Sie in der kasko2go App hinterlegten haben, belastet werden, hat die Simpego das Recht, den im Vertrag festgehaltenen Maximalbetrag sofort einzufordern. Sie erhalten dafür eine Rechnung. Vom Maximalbetrag abgezogen werden dabei die für dieses Versicherungsjahr bereits bezahlten Prämien. Sofern der Vertrag unverändert bleibt, erfolgt für den Rest der Vertragslaufzeit keine weitere Prämienbelastung, Kilometerabrechnung oder Berücksichtigung des kasko2go Scores.',
          },
          {
            headline: 'Forderungen im Zusammenhang mit Schadenfällen',
            text: 'Für Selbstbehalte und Rückforderungen, die im Zusammenhang mit Schadenfällen anfallen, stellen wir Ihnen eine Rechnung zu. Diese Beträge werden nicht der Kreditkarte belastet.',
          },
          {
            headline: 'Bedingungen für die Nutzung von kasko2go powered by Simpego und Folgen bei Zuwiderhandlung',
            text: 'Für die Nutzung von kasko2go powered by Simpego verpflichten Sie sich, dass jede Strecke, die mit dem versicherten Fahrzeug zurückgelegt wird, vom jeweiligen Fahrer mit der kasko2go App gemessen wird. Dafür muss das Gerät eingeschaltet und die kasko2go App aktiviert sein. Sie verpflichten sich zudem, einmal monatlich den Kilometerstand des versicherten Fahrzeuges in der kasko2go App zu deklarieren. Die Simpego hat das Recht jederzeit ein Foto des aktuellen Kilometerstandes von Ihnen einzufordern. Versäumen Sie es trotz wiederholter Aufforderung einen entsprechenden Fotobeweis zu erstellen, hat die Simpego das Recht den Maximalbetrag sofort einzufordern. Vom Maximalbetrag abgezogen werden dabei die für dieses Versicherungsjahr bereits bezahlten Prämien. Sofern der Vertrag unverändert bleibt, erfolgt für den Rest der Vertragslaufzeit keine weitere Prämienbelastung, Kilometerabrechnung oder Berücksichtigung des kasko2Go Scores.',
          },
          {
            headline: 'Differenzen beim Kilometerstand',
            text: 'Werden zwischen dem von Ihnen via kasko2go App gemeldeten Kilometerstand und dem von der kasko2go App gemessenen gefahrenen Kilometern Unterschiede festgestellt, hat die Simpego das Recht, den Maximalbetrag sofort einzufordern. Vom Maximalbetrag abgezogen werden dabei die für dieses Versicherungsjahr bereits bezahlten Prämien. Sofern der Vertrag unverändert bleibt, erfolgt für den Rest der Vertragslaufzeit keine weitere Prämienbelastung, Kilometerabrechnung oder Berücksichtigung des kasko2go Scores.',
          },
          {
            headline: 'Hinterlegung der Kontrollschilder (Sistierung)',
            text: 'kasko2go powered by Simpego Versicherungsverträge, die eine Fixprämie beinhalten, verändern sich nicht, wenn die Kontrollschilder beim Strassenverkehrsamt hinterlegt werden, das versicherte Fahrzeug aber in Ihrem Besitz bleibt. Die Fixprämie ist auch dann fällig, wenn die Kontrollschilder hinterlegt wurden (Stillstandrisikodeckung). kasko2go powered by Simpego Versicherungsverträge, die keine Fixprämie beinhalten, werden per Datum der Schilderhinterlegung aufgehoben.',
          },
          {
            headline: 'Kündigung und Abrechnung',
            text: 'Wird der Vertrag durch Sie oder die Simpego gekündigt, erfolgt die Aufhebung per dem vom Strassenverkehrsamt gemeldeten Datum. Ihrer in der kasko2go App hinterlegten Kreditkarte werden nur noch die bis zur Vertragsaufhebung zurückgelegten Kilometer und der pro rata Anteil der allfälligen Fixprämie belastet. Der Maximalbetrag ist nach einer Aufhebung in den folgenden zwei Fällen immer geschuldet: 1. Sie kündigen den Vertrag aufgrund eines Teilschadens im ersten Versicherungsjahr und die Simpego hat für den Schaden die Versicherungsleistung erbracht; 2. Der Vertrag wird aufgrund eines Totalschadens (und dem damit verbundenen Wegfall des versicherten Risikos) aufgehoben, und die Simpego hat für den Schaden die Versicherungsleistung erbracht. Vom Maximalbetrag abgezogen werden dabei die für dieses Versicherungsjahr bereits bezahlten Prämien. Für die Forderung des Maximalbetrages nach einer Aufhebung stellen wir Ihnen eine Rechnung zu. Diese Beträge werden nicht der Kreditkarte belastet.',
          },
          {
            headline: 'Datenaustausch kasko2go - Simpego',
            text: 'Zwischen der kasko2go AG und der Simpego Versicherungen AG findet ab dem Zeitpunkt der Vertragsaktivierung folgender Datenaustausch statt:',
          },
          {
            text: 'Simpego meldet kasko2go den Vertragsstatus, die Versicherungsdeckung, Prämieninformationen und Daten im Zusammenhang mit Schadenfällen des versicherten Fahrzeuges (Schadendatum, Schadenart, Schadenhergang, Betrag).',
          },
          {
            text: 'kasko2go meldet Simpego die gefahrenen Kilometer im örtlichen Geltungsbereich gemäss AVB, den Transaktionscode der Zahlung, den Score des Fahrverhaltens pro Monat, alle zwecks Antrags- und Vertragsausstellung erhobenen Daten zum Versicherungsnehmer, Lenker, versicherten Fahrzeug und zu den versicherten Deckungen.',
          },
          {
            text: 'Es werden zwischen Simpego und kasko2go, abgesehen vom finalen Score, keine Informationen zu Ihrem Fahrverhalten, keine Daten zu Ihrem Standort oder dem Standort des Fahrzeuges und auch keine weiteren hier nicht genannten Daten ausgetauscht.',
          },
        ],
        privacy: {
          part1: 'Mehr Informationen zum Datenschutz bei Simpego finden Sie im Abschnitt „Datenschutz“ unserer ',
          part2: 'Produktinformationen',
          part3: '.',
        },
      },
    },
  },
  offer: {
    headline: 'Ihre Offerte ist auf dem Weg!',
    text: 'Vielen Dank, dass Sie sich für eine Autoversicherung bei der Simpego interessieren. Wir haben Ihnen Ihre gewünschte Offerte an die von Ihnen angegebene Mail-Adresse gesendet. Bitte überprüfen Sie Ihr Postfach.',
    mailText: 'Falls Sie Fragen haben, melden Sie sich gerne bei uns',
  },
  confirmation: {
    headline: 'Vielen Dank für Ihren Versicherungsabschluss. Willkommen in der Simpego Familie!',
    headlineText: 'Für die Aktivierung Ihrer neuen Autoversicherung benötigen wir noch ein paar wenige Angaben:',
    form: {
      licencePlateAvailable: 'Haben Sie bereits ein Kontrollschild für dieses Fahrzeug?',
      licencePlate: 'Wie lautet Ihr Kontrollschild?',
      licencePlateActive: 'Ist dieses Kontrollschild im Moment eingelöst bzw. im Verkehr?',
      vehicleRegisteredToOwner: 'Ist das Fahrzeug{vehicleModel} zur Zeit bereits auf {policyholder} eingelöst?',
      licencePlateRegisteredToOwner: 'Ist dieses Kontrollschild zur Zeit auf {policyholder} eingelöst?',
      defaultPolicyholder: 'den Versicherungsnehmer',
      registeredToDextra: 'Waren Sie mit diesem Fahrzeug zuvor bei der Simpego versichert?',
      serialNumber: {
        text: 'Bitte geben Sie die Stammnummer des zu versichernden Fahrzeugs an. Wenn Sie die Stammnummer noch nicht kennen oder gerade nicht zur Hand haben, klicken Sie bitte auf den Button «Information später erfassen». Sie haben von uns bereits eine E-Mailbestätigung Ihres Versicherungsabschlusses erhalten, welcher einen Wiedereinstiegslink auf diese Seite enthält. Dort können Sie zu einem späteren Zeitpunkt die fehlenden Angaben nachliefern.<br><br>Bitte beachten Sie, dass wir für die Auslösung eines Versicherungsnachweises zwingend die korrekte Stammnummer benötigen.',
        label: 'Stammnummer',
      },
      btn: {
        submit: 'Versicherungsnachweis bestellen',
        infoLater: 'Informationen später erfassen',
      },
      infoLaterPopup: 'Wenn Sie die Informationen zu einem späteren Zeitpunkt erfassen möchten, ist das kein Problem. Sie haben von uns bereits eine E-Mailbestätigung Ihres Versicherungsabschlusses erhalten.<br>In dieser Email finden Sie einen Link auf diese Seite. Mit Klick auf den Link, kommen Sie jederzeit hierhin zurück und können die fehlenden Angaben nachliefern.<br>Falls Sie Fragen haben, melden Sie sich gerne bei uns <a href="mailto:service@simpego.ch">service@simpego.ch</a>',
      inputTypeQuestions: 'Einlösegrund ermitteln',
      inputTypeDirect: 'Einlösegrund direkt wählen',
    },
    ivReason: {
      label: 'Einlösegrund',
      new: '57 - Neueinlösung',
      reactivation: '52 - WIK A',
      vehicleChange: '58 - Fahrzeugwechsel',
      ownerChange: '59 - Halterwechsel',
      insurerChange: '54 - Versichererwechsel',
      none: 'kein VNA benötigt',
    },
  },
  infoLater: {
    headline: 'Informationen später erfassen!',
    text: 'Wenn Sie die Informationen zu einem späteren Zeitpunkt erfassen möchten, ist das kein Problem. Sie haben von uns bereits eine E-Mailbestätigung Ihres Versicherungsabschlusses erhalten.<br>In dieser Email finden Sie einen Link auf diese Seite. Mit Klick auf den Link, kommen Sie jederzeit hierhin zurück und können die fehlenden Angaben nachliefern.',
    emailText: 'Falls Sie Fragen haben, melden Sie sich gerne bei uns',
    btn: 'Informationen erfassen',
  },
  offerExpired: {
    headline: 'Leider ist Ihre Offerte nicht mehr gültig.',
    text1: 'Falls Sie dazu Fragen haben, melden Sie sich gerne bei unserem Team des Customer Solution Center, das Ihnen lösungsorientierten und freundlichen Service bietet.',
    text2: 'Mo bis Do: 07:30 – 18:00 Uhr und Fr: 07:30 - 17:00 Uhr unter der Nummer: +41 58 521 11 11',
    mailText: 'Oder per Mail ',
    text3: 'Gerne können Sie auch eine neue Offerte rechnen:',
    newInsuranceRequest: 'Jetzt Prämie neu berechnen',
  },
  rejected: {
    headline: 'Hinweis',
    text1: 'Ihre Offerte wird zurzeit von uns bearbeitet, daher ist der Link in Ihrem Mail nicht mehr aktiv. Falls Sie dazu Fragen haben, melden Sie sich gerne bei unserem Team des Customer Solution Center, das Ihnen lösungsorientierten und freundlichen Service bietet.',
  },
  finish: {
    headline: 'Willkommen bei der besten* Autoversicherung der Schweiz !',
    text1: 'Vielen Dank für Ihre Angaben, wie geht es jetzt weiter ?',
    list1: 'Da Ihre Stammnummer jetzt bei uns bekannt ist, schicken wir umgehend dem zuständigen Strassenverkehrsamt den elektronischen Versicherungsnachweis. Sie können Ihr Fahrzeug dann einlösen.',
    list2: 'Sobald Sie Ihr Fahrzeug eingelöst haben, erhalten Sie von uns Ihre Versicherungsunterlagen sowie die Prämienrechnung zugeschickt.',
    hint: '*Jetzt haben wir Sie überzeugt.',
    homeButton: 'Zur Startseite',
  },
  declined: {
    headline: 'Hinweis',
    text1: 'Leider können wir Ihnen zum jetzigen Zeitpunkt keine Versicherung für Ihr Fahrzeug anbieten.',
    text2: 'Wir bitten um Ihr Verständnis.',
    back: 'zurück',
    reason: 'Grund:',
    defaultReason: 'Kein Angebot möglich',
  },
  errorPage: {
    headline: 'Hinweis',
    customerText: 'Es ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Kundenservice.',
    agent: {
      text1: 'Das Aufrufen des für Sie personalisierten Onlinefunnels hat leider nicht geklappt.',
      text2: 'Das kann folgende Gründe haben:',
      text3: '- Es besteht ein technisches Problem mit dieser Seite.',
      text4: '- Ihr Vermittlerprofil wartet Simpego-Intern noch auf Freischaltung.',
      text5: '- Ihr Vermittlerprofil wurde gesperrt.',
      mail: 'Bitte melden Sie diesen Fehler unserem Customer Solution Center per Mail',
      tel: 'oder telefonisch unter der Nummer +41 58 521 11 11.',
      text6: 'Wir sind erreichbar von Mo bis Do: 07:30 – 18:00 Uhr und Fr: 07:30 - 17:00 Uhr.',
    },
  },
  mediator: {
    mediatorData: 'Vermittlerdaten',
    mediatorName: 'Vermittlername/-firma',
    mediatorID: 'Vermittler ID',
    refreshWarning: 'Wollen Sie eine neue Berechnung starten? (Bereits erfasste Daten gehen verloren!)',
    endSessionWarning: 'Wollen Sie Ihre Vermittler Authentifizierung entfernen? (Bereits erfasste Daten gehen verloren)',
  },
  servicePage: {
    headline: 'Wir brauchen einen Boxenstopp!',
    content: 'Diese Seite wird gerade gewartet.<br> Deshalb können wir Ihnen leider momentan keine Preisberechnung anbieten.<br> Bitte versuchen Sie es zu einem späteren Zeitpunkt noch einmal - vielen Dank! <br><br> Ihr Simpego Team',
  },
  validation: {
    messages: {
      required: 'Bitte beantworten Sie diese Frage.',
      validate_integer: 'Bitte geben Sie eine korrekte Zahl an.',
    },
    custom: {
      ownedSince: {
        required: 'Bitte wählen Sie das Jahr aus, in dem Sie das Auto gekauft haben.',
      },
      businessUsage: {
        required: 'Bitte geben Sie an, ob das Auto von Ihnen privat oder geschäftlich genutzt wird.',
      },
      canton: {
        required: 'Bitte wählen Sie das Kanton aus, in dem das Auto versichert werden soll.',
      },
      leasing: {
        required: 'Bitte geben Sie an, ob Sie das Auto geleast haben.',
      },
      nationality: {
        required: 'Bitte geben Sie Ihre Nationalität an.',
      },
      otherNationality: {
        required: 'Bitte geben Sie Ihre Nationalität an.',
      },
      residencePermit: {
        required: 'Bitte geben Sie Ihre Aufenthaltsbewilligung an.',
      },
      driverLicenceSinceYear: {
        required: 'Bitte geben Sie das Jahr an, seit dem Sie ein Fahrzeug im Verkehr führen dürfen.',
        min: 'Bitte geben Sie das Jahr an, seit dem Sie ein Fahrzeug im Verkehr führen dürfen.',
        between: 'Der Halter muss zum Zeitpunkt der Prüfung mindestens 18 Jahre alt sein',
      },
      agentEmail: {
        required: 'Bitte geben Sie Ihre Vermittler-Email an.',
      },
      customerDocuments: {
        required: 'Bitte geben Sie den Dokumentenversand an.',
      },
      gender: {
        required: 'Bitte geben Sie Ihre Anrede an.',
      },
      firstName: {
        required: 'Bitte geben Sie Ihren Vornamen an.',
      },
      lastName: {
        required: 'Bitte geben Sie Ihren Nachnamen an.',
      },
      street: {
        required: 'Bitte geben Sie Ihre Strasse an.',
      },
      houseNumber: {
        required: 'Bitte geben Sie Ihre Hausnummer an.',
      },
      zip: {
        required: 'Bitte geben Sie Ihre PLZ an.',
        digits: 'Bitte geben Sie eine 4 stellige PLZ an.',
        validate_zipcode: 'Bitte geben Sie eine gültige PLZ an.',
      },
      city: {
        required: 'Bitte geben Sie Ihren Wohnort an.',
      },
      email: {
        required: 'Bitte geben Sie Ihre E-Mail an.',
        email: 'Bitte geben Sie eine gültige E-Mail Adresse an.',
        validate_email: 'Bitte geben Sie eine gültige E-Mail Adresse an.',
        umlaut_email: 'Die Mailadresse ist nicht gültig, sie darf kein ä, ö oder ü enthalten.',
      },
      age: {
        required: 'Bitte geben Sie Ihr Alter an.',
        validate_ageOrYear_16: 'Bitte geben Sie ein Alter zwischen 16 und 99 Jahren ein.',
        validate_ageOrYear_18: 'Bitte geben Sie ein Alter zwischen 18 und 99 Jahren ein.',
      },
      nationalitySwiss: {
        required: 'Bitte geben Sie Ihre Nationalität an.',
      },
      phone: {
        required: 'Sie haben sich für ein Abrechnungsmodel mit Tracking (FlexDrive oder BonusDrive) entschieden. Bitte geben Sie die Mobilfunknummer des Smartphones an, auf dem Sie die App zum Tracken des Fahrverhaltens installieren möchten.',
        validate_mobile_phone: 'Sie haben sich für ein Abrechnungsmodel mit Tracking (FlexDrive oder BonusDrive) entschieden. Wir benötigen die Mobilfunknummer des Smartphones, auf dem Sie die App zum Tracken des Fahrverhaltens installieren möchten. Die angegebene Nummer scheint keine (valide) Mobilenummer zu sein.',
        validate_phone: 'Bitte prüfen Sie Ihre Eingabe. Keine gültige Telefonnummer. Geben Sie eine gültige Nummer an oder entfernen Sie die Nummer.',
      },
      dateOfBirth: {
        required: 'Bitte geben Sie Ihr Geburtsdatum an.',
        date_format: 'Bitte geben Sie das Datum in folgendem Format an: TT.MM.JJJJ',
        validate_ageMin: 'Sie haben Ihr Alter im 1. Schritt eingegeben. Sie können nicht jünger als Ihr zuvor angegebenes Alter sein',
        validate_ageMax: 'Sie haben Ihr Alter im 1. Schritt eingegeben. Sie können nicht älter als Ihr zuvor angegebenes Alter sein',
      },
      startOfInsurance: {
        required: 'Bitte geben Sie das Datum des Versicherungsstarts an.',
        after: 'Das von Ihnen eingegebene Datum liegt in der Vergangenheit. Bitte geben Sie ein aktuelles Datum an.',
        before: 'Bitte geben Sie ein Datum an, das innerhalb der nächsten 12 Monate liegt.',
        date_format: 'Bitte geben Sie das Datum in folgendem Format an: TT.MM.JJJJ',
      },
      initialRegistrationYear: {
        required: 'Bitte geben Sie das Jahr der ersten Inverkehrssetzung ein.',
      },
      brand: {
        required: 'Bitte wählen Sie zunächst die Marke, dann das Modell aus.',
      },
      model: {
        required: 'Bitte wählen Sie zusätzlich zu der Marke noch das Modell aus.',
      },
      typenumber: {
        required: 'Fahrzeug wurde nicht gefunden. Bitte überprüfen Sie Ihre Eingabe oder nutzen Sie die Fahrzeugsuche.',
        digits: 'Fahrzeug wurde nicht gefunden. Bitte überprüfen Sie Ihre Eingabe oder nutzen Sie die Fahrzeugsuche.',
      },
      typeCertificateNumber: {
        required: 'Bitte geben Sie den Typenschein an.',
        regex: 'Bitte überprüfen Sie die Typenscheinnummer (6-stellig)',
      },
      licencePlate: {
        required: 'Bitte geben Sie Ihr Kontrollschild an.',
        digits: 'Bitte überprüfen Sie das Kontrollschild.',
        regex: 'Bitte überprüfen Sie das Kontrollschild.',
        between: 'Kontrollschildnummer muss zwischen 1 und 999999 liegen.',
      },
      partially_comprehensive: {
        park_damage_deductible: {
          max_value: 'Der Selbstbehalt muss mind. CHF 100 niedriger sein als der Selbstbehalt im Fall einer Kollision. Bei einem Selbstbehalt im Fall einer Kollision von CHF 0 muss der Selbstbehalt Parkschaden ebenfalls CHF 0 sein.',
        },
        personal_effects_coverage: {
          in: 'Es sind nur CHF 0, CHF 1\´000, CHF 2\´000, CHF 3\´000, CHF 4\´000 oder CHF 5\´000 erlaubt',
        },
        protective_clothing: {
          between: 'Der Wert der Schutzbekleidung muss zwischen CHF 0 (= nicht versichert) und CHF 5\´000 sein.',
        },
      },
      fully_comprehensive: {
        deductible1: {
          min_value: 'Der Selbstbehalt muss mind. CHF 100 höher sein als der Selbstbehalt im Fall eines Parkschaden.',
          in: 'Bitte geben Sie den Wert in 100er Schritten an.',
          between: 'Bei nicht versichertem Parkschadenschutz muss der Selbstbehalt zwischen CHF 0 und CHF 10\´000 sein.',
        },
        deductible2: {
          in: 'Bitte geben Sie den Wert in 100er Schritten an.',
          between: 'Bei nicht versichertem Parkschadenschutz muss der Selbstbehalt zwischen CHF 500 und CHF 10\´000 sein.',
        },
      },
      legal: {
        required: 'Um fortfahren zu können, bestätigen Sie bitte die zur Kenntnisnahme der genannten Dokumente.',
      },
      legalAgent: {
        required: 'Um fortfahren zu können, bestätigen Sie bitte, dass der Kunde die für ihn gültigen Dokumente und Bedingungen akzeptiert und Sie berechtigt sind diesen Vertragsabschluss durchzuführen.',
      },
      serialNumber: {
        regex: 'Bitte überprüfen Sie das Format',
        validate_serial_number: 'Bitte überprüfen Sie Ihre eingegebene Stammnummer auf Fehler.',
      },
      youngDriver: {
        validate_driverUnderTwentyfive: 'Sie haben angegeben unter 25 Jahre alt zu sein, daher können Sie diese Frage nicht verneinen.',
      },
    },
  },
  rateListItems: {
    liability: 'Haftpflicht',
    deductible: 'Selbstbehalt CHF&nbsp;{value}',
    partially_comprehensive: 'Teilkasko',
    fully_comprehensive: 'Kollisionskasko',
    gross_negligence: 'Grobfahrlässigkeits&shy;schutz',
    passenger_accident: 'Unfall <span>{bundle}</span>',
    '24_assistance': '24h-Assistance <span>{bundle}</span>',
    daily_termination: 'Tägliches Kündigungsrecht',
    Basis: 'Basis',
    Plus: 'Plus',
    Standard: 'Standard',
    not_covered: 'nicht versichert',
    unlimited: 'unlimitiert',
    yes: 'ja',
    protective_clothing: 'Schutzbekleidung',
    free_garage: {
      headline: 'Reparaturmodell: {value}',
      accordionText: '<p>{free_garage}</p>',
    },
    glass: {
      Basis: 'nicht versichert',
      Plus: 'versichert',
    },
    flexDrive: {
      headline: 'FlexDrive',
      accordionText: 'Kilometergenaue Abrechnung nach tatsächlich gefahrenen Kilometern. Die Wahl zwischen den Abrechnungsmodellen kann auf den nachfolgenden Seiten „Deckung anpassen“ oder bei Schritt 3 nach den Halterangaben getroffen werden.',
    },
    DexCarM: {
      liability: '<p>Versicherungssumme:<br>CHF&nbsp;{insuarance_sum_value}&nbsp;Mio</p><p>Selbstbehalt für nicht deklarierte Lenker bis 25 Jahre:<br>+ CHF&nbsp;{value_under_25}</p>',
      partially_comprehensive: '<p>Glas Plus (Kleinglas):<br>{glas_package}</p><p>Mitgeführte Sachen:<br>{personal_effects_coverage}</p>',
      fully_comprehensive: '<p>Parkschadenschutz:<br>{park_damage_value}</p><p>Parkschadenschutz Selbstbehalt:<br>{park_damage_deductible}</p><p>Selbstbehalt für nicht deklarierte Lenker bis 25 Jahre:<br>+ CHF&nbsp;{value_under_25}</p>',
      gross_negligence: '<p>{negligence}</p>',
      passenger_accident: 'Unfall Standard',
      '24_assistance': '24h-Assistance Basis',
    },
    DexCarL: {
      liability: '<p>Versicherungssumme:<br>CHF&nbsp;{insuarance_sum_value}&nbsp;Mio</p><p>Selbstbehalt für nicht deklarierte Lenker bis 25 Jahre:<br>+ CHF&nbsp;{value_under_25}</p>',
      partially_comprehensive: '<p>Glas Plus (Kleinglas):<br>{glas_package}</p><p>Mitgeführte Sachen:<br>{personal_effects_coverage}</p>',
      fully_comprehensive: '<p>Parkschadenschutz:<br>{park_damage_value}</p><p>Parkschadenschutz Selbstbehalt:<br>{park_damage_deductible}</p><p>Selbstbehalt für nicht deklarierte Lenker bis 25 Jahre:<br>+ CHF&nbsp;{value_under_25}</p>',
      gross_negligence: '<p>{negligence}</p>',
      passenger_accident: '<p>Personenkreis:<br>Alle Insassen</p><p>Todesfall:<br>{death_benefit}</p><p>Invalidität:<br>{disability_capital}</p><p>Tages- und Spitalgeld:<br>je&nbsp;{daily_compensation}</p>',
      '24_assistance': '<p>Abschleppen in:<br>nächste Garage</p><p>Rückreise und Mobilität<br> (z.B. Ersatz-/Mietwagen)<br>bis CHF&nbsp;1&#xFEFF;\´500</p>',
    },
    DexCarXl: {
      liability: '<p>Versicherungssumme:<br>CHF&nbsp;{insuarance_sum_value}&nbsp;Mio</p><p>Selbstbehalt für nicht deklarierte Lenker bis 25 Jahre:<br>+ CHF&nbsp;{value_under_25}</p>',
      partially_comprehensive: '<p>Glas Plus (Kleinglas):<br>{glas_package}</p><p>Mitgeführte Sachen:<br>{personal_effects_coverage}</p>',
      fully_comprehensive: '<p>Parkschadenschutz:<br>{park_damage_value}</p><p>Parkschadenschutz Selbstbehalt:<br>{park_damage_deductible}</p><p>Selbstbehalt für nicht deklarierte Lenker bis 25 Jahre:<br>+ CHF&nbsp;{value_under_25}</p>',
      gross_negligence: '<p>{negligence}</p>',
      passenger_accident: '<p>Personenkreis:<br>Alle Insassen</p><p>Todesfall:<br>{death_benefit}</p><p>Invalidität:<br>{disability_capital}</p><p>Tages- und Spitalgeld:<br>je&nbsp;{daily_compensation}</p>',
      '24_assistance': '<p>Abschleppen in:<br>Garage nach Wahl</p><p>Rückreise und Mobilität<br> (z.B. Ersatz-/Mietwagen)<br>bis CHF 4&#xFEFF;\´000</p>',
    },
  },
  billingModels: {
    flex_drive: 'FlexDrive',
    flat_rate: 'BasisDrive',
    bonus_drive: 'BonusDrive',
  },
  billingModelChooser: {
    trackingDrivingBehaviour: 'Tracking des Fahrverhaltens',
    chooseBillingModel: 'Abrechnungsmodel wählen',
    bonusDriveExplanation: '(BasisDrive mit Tracking)',
    headlineInfoText: {
      flex_drive: "<p>Die Gesamtprämie setzt sich aus einer Fixprämie (stehende Risiken (Teilkasko)) und der variablen Prämie (fahrende Risiken (Kollisionskasko, Haftpflicht, Grobfahrlässigkeit)) zusammen. Die Gesamtprämie (CAP) ist gedeckelt (garantierte maximale Jahresprämie).</p><br><p>Wie ist der CAP berechnet: Fixprämie pro Jahr + Kilometerprämien für 12'000 Kilometer. FlexDrive wird monatlich per Kreditkarte abgerechnet.</p><br><p>Die gefahrenen Kilometer werden pro Monat pro Versicherungsjahr sowie der Score (Fahrverhalten) über die App gemeldet. Der Score kann die Kilometerbasierte Prämie reduzieren aber nicht erhöhen.</p><br><p>Sobald Ihr Vertrag policiert wurde, erhalten Sie eine SMS und eine EMAIL mit Anweisungen für Download der APP und zur Anmeldung. Für simpego FlexDrive benötigt man eine aktivierte simpego FlexDrive App. Sobald man der App erlaubt, seine Fahrten zu überwachen, wird sie im Hintergrund ausgeführt. Man  muss die App nicht jedes Mal neu starten oder etwas Spezielles tun, wenn man losfährt.</p>",
      bonus_drive: '<p>Sobald Ihr Vertrag policiert wurde, erhalten Sie eine SMS und eine EMAIL mit Anweisungen für Download der APP und zur Anmeldung.</p><br><p>Die simpego FlexDrive APP wird im Hintergrund ausgeführt, um zu verfolgen, wie Sie fahren. Möglicherweise erhalten Sie gelegentlich Meldungen, die Sie daran erinnern, das WLAN eingeschaltet zu lassen oder die App neu zu starten, wenn sie aus irgendeinem Grund nicht mehr funktioniert. Ihr Fahrerergebnis wird angezeigt, wenn Sie Ihre ersten 10 Fahrten absolviert haben (siehe die Trip Tracker-Karte in der App). Sie können die Liste Ihrer bisherigen Fahrten sehen. Basierend auf Ihrer Fahrleistung wird Ihre Punktzahl aktualisiert und auf dem Hauptbildschirm der App angezeigt. Wir werden uns ein Bild davon machen, was für ein Fahrer Sie sind, Ihnen helfen, besser zu werden, und Ihnen obendrein einen Rabatt auf Ihre Versicherung verschaffen.</p>',
    },
    subline: {
      flex_drive: 'FlexDrive ist eine kilometergenaue Abrechnung, bei der man nur die tatsächlich gefahrenen Kilometer bezahlt. Die Gesamtprämie setzt sich aus einer jährlichen <a href="https://www.simpego.ch/flexdrive-de" target="blank">Fixprämie</a> der <a href="https://www.simpego.ch/flexdrive-de" target="blank">variablen Prämie</a> (Prämie pro Kilometer) sowie dem <a href="https://www.simpego.ch/flexdrive-de" target="blank">Fahrverhalten</a> zusammen. Das Fahrverhalten wird mit einer App getrackt und in einen Score umgewandelt. Dieser kann die tatsächlich zu bezahlende Prämie pro Kilometer senken, aber nicht erhöhen.',
      flat_rate: 'Die Prämie wird pro Vertragsjahr festgesetzt und ist im Voraus zu bezahlen. Die Höhe hängt von den versicherten Risiken und der vereinbarten Leistung ab.',
      bonus_drive: 'Die Prämie wird pro Vertragsjahr festgesetzt und ist im Voraus zu bezahlen. Die Höhe hängt von den versicherten Risiken und der vereinbarten Leistung ab. Während des Versicherungsjahres können Sie sich Ihren Bonus erfahren und sich so für das nächste Versicherungsjahr einen Rabatt auf Ihre Versicherung erfahren.',
    },
    trackingDrivingBehaviourInfoText: '<p>Das Tracking des Fahrverhaltens ist Bestandteil von FlexDrive und BonusDrive.</p><br><p>Für das Tracking des Fahrverhaltens benötigt man die Simpego FlexDrive App. Sobald der Vertrag policiert wurde, erhalten Sie eine SMS und eine EMAIL mit Anweisungen für Download der APP und zur Anmeldung. Sobald der App erlaubt wird, die Fahrten zu überwachen, wird sie im Hintergrund ausgeführt. Die App muss nicht jedes Mal neu gestartet oder es muss nichts Spezielles getan werden, bevor man losfährt. Nach Registrierung in der APP erhält man per Mail alle weiteren Informationen.</p>',
  },
  productInfoText: {
    DexCarM: 'Unsere Prämie für Sparfüchse. Alles dabei was Sie als Lenker brauchen: Haftpflicht, Teilkasko und Kollisionsschutz.',
    DexCarL: 'Unser beliebtestes Produkt. Profitieren Sie von überdurchschnittlichen Leistungen zu tollen Prämien, inkl. Unfallversicherung, Grobfahrlässigkeit und 24-Stunden Assistance.',
    DexCarXl: 'Der Geheimtipp auf dem Markt. Unser Produkt für alle, die unlimitierten Schutz mit minimalem Selbstbehalt schätzen. Beste Konditionen für Haftpflicht, Teilkasko, Kollisionsschutz, Unfallversicherung, Grobfahrlässigkeit und 24-Stunden Assistance.',
    billingModelInfo: 'Sie können zwischen dem Abrechnungsmodell BasisDrive, FlexDrive oder BasisDrive mit Tracking ihres Fahrverhaltens wählen. FlexDrive ist die kilometergenaue Abrechnung, bei der man nur für die tatsächlich gefahrenen Kilometer bezahlt. Steht das Auto in der Garage oder ist man mal eher weniger unterwegs, spart man automatisch Prämie. Und dank monatlicher Abrechnung behält man immer den Überblick! BonusDrive und FlexDrive ist derzeit für Motorräder und Firmenkunden noch nicht rechenbar. <a href="https://blog.simpego.ch/abrechnungsmodelle-autoversicherung/" target="blank">Weitere Infos gibt es hier</a>',
  },
  file: {
    select: 'Datei auswählen',
    clear: 'Eingabefeld leeren',
  },
}
